import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NoteEtoiles from './NoteEtoiles';
import { chargerAvis, sAbonner, instantane } from './avisService';

// La note affichee dans la hero. Elle n'apparait qu'a partir de trois avis :
// en dessous, une moyenne ne veut rien dire et un "5 sur 5" sur un seul avis
// fait plus de mal que de bien.
const SEUIL = 3;

export default function NoteHero() {
  const [etat, setEtat] = useState(instantane());

  useEffect(() => {
    const desabonner = sAbonner(setEtat);
    chargerAvis();
    return desabonner;
  }, []);

  if (!etat.total || etat.total < SEUIL || !etat.moyenne) return null;

  return (
    <Link
      to="/#avis"
      className="mt-7 inline-flex items-center gap-3 rounded-[3px] border border-white/20 bg-white/8 px-4 py-2.5 transition-colors hover:border-jaune/60"
    >
      <NoteEtoiles note={etat.moyenne} taille={17} classe="text-jaune" />
      <span className="font-display text-[18px] text-white leading-none">
        {String(etat.moyenne).replace('.', ',')}
        <span className="text-white/60 text-[14px]"> sur 5</span>
      </span>
      <span className="font-cond uppercase tracking-[0.08em] text-[12.5px] text-white/60">
        {etat.total} avis clients
      </span>
    </Link>
  );
}
